var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('PageHeader'),_c('h1',{staticClass:"title"},[_vm._v("Home")]),_c('ProductList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }